module.exports = __webpack_public_path__ + "static/media/bonlogo.ffc94267.png";